import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { computed } from '@vue/reactivity';
import { defineComponent, ref, } from 'vue';

// icons
import { add, close, arrowBack, arrowForward, } from 'ionicons/icons';

// components
import {
  IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonButtons,
  IonList, IonItem, IonLabel, IonInput, IonTextarea, IonIcon, IonCheckbox, IonFooter,
  modalController
} from '@ionic/vue';

import config from '@/config';
import { useStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'RoleInClassSelectModal',
  props: ["initialSection", "prefilledRole", "prefilledClasses"],
  setup(__props) {

// vue
const props = __props;

const section = ref(props.initialSection || 1); // role -> classes

const customRole = ref("");
const selectedRole = ref(props.prefilledRole || "");

const customClass = ref("");
const selectedClasses = ref<any>(props.prefilledClasses?.slice() || []);
const extraClasses = ref<any>(props.prefilledClasses?.slice() || []);

// store variables
const store = useStore();
const allElectives = computed(() => store.state.allElectives);

const getTitle = () => {
  if (section.value == 1) return `Select your role`;
  return `You are a ${selectedRole.value} in class(es):`;
};
const cancelChanges = async () => (await modalController.dismiss({}));
const confirmChanges = async (selectedRole, selectedClasses) => (await modalController.dismiss({ selectedRole, selectedClasses, }));

// Roles
const rolesInClass = () => {
  const baseRoles = [props.prefilledRole, 'Class teacher', ...(config.coreSubjects.map(s => `${s} teacher`))];
  const roles = baseRoles.concat(allElectives.value.map(e => (`${e.shortName || e.name} teacher`)));
  return [...new Set(roles.filter(r => r))];
};
const onSelectRole = (role) => {
  if (role) {
    selectedRole.value = role.trim();
    section.value = 2; // select class(es)
  }
};

// Classes
const allClasses = () => {
  const basicClasses: any = [];
  for (let form = 1; form <= 6; form++) {
    for (const label of ['A', 'B', 'C', 'D', 'E', 'F']) {
      basicClasses.push(`${form}${label}`);
    }
  }
  return [...new Set(extraClasses.value.concat(basicClasses))];
};

const onAddNewClass = () => {
    if (customClass.value) {
      const newClass = customClass.value.trim().toUpperCase();
      selectedClasses.value.unshift(newClass);
      customClass.value = '';
      extraClasses.value.unshift(newClass); // put to front
    }
};
const isChecked = (value) => (selectedClasses.value.find((item) => item === value) !== undefined);
const checkboxChange = (ev) => {
  const { checked, value } = ev.detail;
  if (checked){
    selectedClasses.value.push(value);
  } else {
    selectedClasses.value = selectedClasses.value.filter(cl => cl != value);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (section.value == 1 ? cancelChanges() : section.value = 1))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), { icon: _unref(arrowBack) }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, __props.initialSection != 2]
            ]),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(getTitle()), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonItem), {
              lines: "none",
              fill: "outline"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_unref(IonButton), {
                  slot: "start",
                  size: "normal",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onSelectRole(customRole.value)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "start",
                      icon: _unref(add)
                    }, null, 8, ["icon"]),
                    _cache[7] || (_cache[7] = _createTextVNode(" Add "))
                  ]),
                  _: 1,
                  __: [7]
                }, 512), [
                  [_vShow, customRole.value]
                ]),
                _createVNode(_unref(IonInput), {
                  type: "text",
                  modelValue: customRole.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((customRole).value = $event)),
                  placeholder: "Type here if your role is not listed"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, section.value == 1]
        ]),
        _withDirectives(_createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonItem), {
              lines: "none",
              fill: "outline"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_unref(IonButton), {
                  slot: "start",
                  size: "normal",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (onAddNewClass()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "start",
                      icon: _unref(add)
                    }, null, 8, ["icon"]),
                    _cache[8] || (_cache[8] = _createTextVNode(" Add "))
                  ]),
                  _: 1,
                  __: [8]
                }, 512), [
                  [_vShow, customClass.value]
                ]),
                _createVNode(_unref(IonInput), {
                  type: "text",
                  modelValue: customClass.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((customClass).value = $event)),
                  placeholder: "Type here if your class is not listed",
                  autocapitalize: "characters"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, section.value == 2]
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_unref(IonList), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rolesInClass(), (role) => {
              return (_openBlock(), _createBlock(_unref(IonItem), {
                key: role,
                button: "",
                detail: "",
                onClick: ($event: any) => (onSelectRole(role))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(role), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 512), [
          [_vShow, section.value == 1]
        ]),
        _withDirectives(_createVNode(_unref(IonList), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allClasses(), (cl) => {
              return (_openBlock(), _createBlock(_unref(IonItem), {
                key: cl,
                button: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCheckbox), {
                    "label-placement": "end",
                    justify: "start",
                    value: cl,
                    checked: isChecked(cl),
                    onIonChange: _cache[5] || (_cache[5] = ($event: any) => (checkboxChange($event)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(cl), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "checked"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 512), [
          [_vShow, section.value == 2]
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_unref(IonFooter), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButton), {
              color: "success",
              expand: "block",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (confirmChanges(selectedRole.value, selectedClasses.value)))
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode(" Confirm ")
              ])),
              _: 1,
              __: [9]
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, section.value == 2 && selectedClasses.value.length > 0]
    ])
  ], 64))
}
}

})